<template>
<div class="dialog">
<div class="mask"></div>
 <div class="dialog-content" style="width: 35%;left: 25%;">
   <div v-if="success" class="text F1-M-24" style="margin-bottom: 5%;">
     インポート結果
   </div>
   <div v-else class="text F1-M-24" style="margin-bottom: 5%;">
     インポートエラー
   </div>
   <div style="overflow-y:scroll;height:300px;" >
    <table style="margin-left: 6%;
    margin-top: 1%;
    margin-bottom: 1%;">
       <tbody >
         <tr class="text F1-M-24" style="margin-top:8%;margin-bottom:7%;text-align:left;" v-for='(item,index) in errorList' :key="index" >
           <td>
             {{item}}
           </td>
         </tr>
       </tbody>
    </table>
   </div>
     <div class="btn-group" style="margin-bottom:1%;margin-top: 5%;">
       <div style="width:40%">
        <button class="btn btn-default F2-M-24 bgc1" @click="submit">{{ modal.confirmButtonText }}</button>
       </div>
      <div v-if="modal.showNo" class="divMargin" style="width:40%">
        <button  class="btn btn-default F2-M-24 bgc1" @click="cancel">
          {{ modal.cancelButtonText }}
        </button>
      </div>
     </div>
</div>
</div>
</template>

<script scoped>
export default {
  name: 'messageDialog',
  props: {
    dialogOption: Object
  },
  data () {
    return {
      resolve: '',
      reject: '',
      promise: '', // 保存promise对象
      errorList: [],
      success: false
    }
  },
  computed: {
    modal: function () {
      let options = this.dialogOption
      return {
        showNo: options.showNo || false,
        text: options.text,
        cancelButtonText: options.cancelButtonText
          ? options.cancelButtonText
          : 'いいえ',
        confirmButtonText: options.confirmButtonText
          ? options.confirmButtonText
          : 'はい'
      }
    }
  },
  methods: {
    // 确定,将promise断定为完成态
    submit () {
      this.resolve('submit')
    },
    // 取消,将promise断定为reject状态
    cancel () {
      this.reject('cancel')
    },
    // 显示confirm弹出,并创建promise对象，给父组件调用
    confirm () {
      this.promise = new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
      return this.promise // 返回promise对象,给父级组件调用
    }
  }
}
</script>

<style lang="scss">
.dialog {
  .dialog-content {
    position: relative;
    top: 30%;    
    margin: 0px auto;
    position: fixed;
    box-sizing: border-box;    
    border-radius: 5px;
    background: #fff;
    z-index: 50002;
    .btn-group {
      display: flex;
      bottom: 10px;
      justify-content:center;
      .btn {
        padding: 0;
        width: 100%;
        border-radius: 10px;
        height: 40px;
      }
    }
  }
  .mask {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 50001;
    background: rgba(0, 0, 0, 0.5);
  }
  .divMargin{
    margin-left: 20px;
  }
  .window-table{
        font-size: 16px;
        border: 1px solid #959595;
    }

}
</style>



// WEBPACK FOOTER //
// src/components/CsvResulstDialog.vue